

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Bando } from "src/app/models/bando.model";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { MandatoDiPagamento } from "src/app/models/mandatoDiPagamento.model";
import { Oda } from "src/app/models/oda.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";
import { MandatiDiPagamentoService } from "src/app/services/mandatiDiPagamento.service";
import { OdaService } from "src/app/services/oda.service";


@Component({
  templateUrl: "./dialog-emetti-mdp.component.html",
  styleUrls: ["../bef.component.css"],
  providers: [MessageService]
})
export class EmettiMdpComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
 
  public emettiMdpForm: FormGroup;
  protected isEmittingMdp:Boolean = false;
  protected oda:Oda;
  protected valoreFase1:number;
  protected valoreFase2:number;
  protected valoreOpereExtra:number;
  protected valoreFase3:number;
  protected valoreKO:number;
  protected valoreTotale:number;



  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private messageService: MessageService,
    private _formBuilder: FormBuilder,
    private mdpService:MandatiDiPagamentoService,
  ) {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    this.oda = this.config.data.oda;
    this.valoreFase1      = this.config.data.fase1;
    this.valoreFase2      = this.config.data.fase2;
    this.valoreOpereExtra = this.config.data.opereExtra;
    this.valoreFase3      = this.config.data.fase3;
    this.valoreKO         = this.config.data.ko;
    this.valoreTotale     = this.valoreFase1  + this.valoreFase2 + this.valoreOpereExtra + this.valoreFase3 + this.valoreKO;

    this.emettiMdpForm = this._formBuilder.group({
      fase1:                      new FormControl({value: this.valoreFase1, disabled: true}, Validators.required),
      fase2:                      new FormControl({value:this.valoreFase2, disabled: true}, Validators.required),
      opereExtra:                      new FormControl({value:this.valoreOpereExtra, disabled: true}, Validators.required),
      fase3:                      new FormControl({value: this.valoreFase3, disabled: true}, Validators.required),
      ko:                         new FormControl({value: this.valoreKO, disabled: true}, Validators.required),
      valore:                     new FormControl({value: this.valoreTotale, disabled: true}, Validators.required),
      intervalloRiferimento :     new FormControl({value: [firstDayOfMonth, lastDayOfMonth], disabled: false}, Validators.required),
    });

  }

  ngOnInit(): void {
    
    
  }

 

  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isEmittingMdp = true;
      let mandatoDiPagamento:MandatoDiPagamento = new MandatoDiPagamento();
      mandatoDiPagamento.oda                      = this.oda;
      mandatoDiPagamento.valore                   =  this.valoreTotale;
      mandatoDiPagamento.inizioPeriodoRiferimento = this.emettiMdpForm.value.intervalloRiferimento[0];
      mandatoDiPagamento.finePeriodoRiferimento   = this.emettiMdpForm.value.intervalloRiferimento[1];
      this.logger.info(mandatoDiPagamento);

        this.mdpService.crea(mandatoDiPagamento).subscribe( {
            next: (resCreaMdp) => {
              this.isEmittingMdp = false;
              this.dialogRef.close({ success: true });
            },
            error: (e) => {
                this.isEmittingMdp = false;
                this.logger.error(e);
                this.dialogRef.close({ success: false });
                this.messageService.add({
                  severity: "error",
                  summary: "ATTENZIONE",
                  detail: "Errore in fase di creazione del mandato di pagamento!", life:10000
                });
            },
            complete: () => {

            }
        });  
    }
  }
}
